import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Logo from "../images/logoss.png";
import "../styles/forgot.css";

// Email regex
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const ForgotPassword = () => {
  const { requestPasswordResetOtp } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const isEmailValid = emailRegex.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);

    try {
      const res = await requestPasswordResetOtp(email);

      if (res.error) {
        setError(res.error);
      } else {
        setMessage("OTP has been sent to your email.");
        setTimeout(() => {
          navigate(`/verify-password?email=${encodeURIComponent(email)}`);
        }, 1500);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left side - background image */}
      <div className="login-left">
        <div className="login-left-content">
          <h2>SubnetExpress</h2>
          <p>
            Reset your password and get back to seamless access to digital
            services.
          </p>
        </div>
      </div>

      {/* Right side - forgot form */}
      <div className="login-right">
        <div className="login-box">
          <img src={Logo} alt="Logo" className="login-logo" />
          <div className="logo-cont">
            <h2 className="login-title">Forgot Password?</h2>
            <p className="login-subtext">
              Enter your registered email to receive an OTP.
            </p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="input-container input-cont-first">
                <label>Email Address</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={!isEmailValid && email ? "error" : ""}
                />
                {!isEmailValid && email && (
                  <p className="error-input">Invalid Email Address</p>
                )}
              </div>

               {error && <p className="error-text error-adj">{error}</p>}
              {message && <p className="bulk-success error-adj">{message}</p>}

              <button type="submit" className="login-btn" disabled={!isEmailValid || loading}>
                {loading ? <div className="spinner"></div> : "Send OTP"}
              </button>

             
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
